var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"4px"}},[_vm._t("default"),_c('img',{attrs:{"src":_vm.getSrc}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }